import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Box,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { baseurl } from "domain";

function EditBooking() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const payment_id = queryParams.get("payment_id");

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    date: "",
    start_time: "",
    end_time: "",
    duration: "",
    name: "",
    email: "",
    phnNo: "",
    amount: "",
    insName: "",
    subCatType: "",
    bookedBy: "",
    gstNo: "",
    govId: "",
    subject: "",
    address: "",
    pinCode : "",
    remark : "",
  });
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    if (payment_id) {
      fetchBookingDetails();
    }
  }, [payment_id]);

  const fetchBookingDetails = async () => {
    try {
      const response = await axios.get(
        `https://${baseurl}/getBookingDetails?payment_id=${payment_id}`
      );
      setBooking(response.data.booking);
      setFormData(response.data.booking);
    } catch (error) {
      console.error("Error fetching booking details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Check if modified by comparing with original data
      setIsModified(JSON.stringify(updatedData) !== JSON.stringify(booking));
      
      return updatedData;
    });
  };

  const a_name = localStorage.getItem("name")

  const handleUpdateBooking = async () => {
    if (!isModified) {
      alert("No changes detected.");
      return;
    }

    try {
      await axios.post(`https://${baseurl}/modify_booking_conf`, {
        payment_id,
        ...formData,
        a_name
      });

      alert("Booking successfully updated.");
      navigate(`/managePressConfHall`);
    } catch (error) {
      console.error("Error updating booking:", error);
      alert(error.response.data.error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" gutterBottom>
            Edit Booking
          </Typography>

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : booking ? (
            <Grid container spacing={3}>
              {/* Editable Fields */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date"
                  type="date"
                  name="date"
                  value={formData.date}
                  // onChange={handleChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Type"
                  name="subCatType"
                  value={formData.subCatType}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                  // onChange={handleChange}
                >
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Start Time"
                  type="time"
                  name="start_time"
                  value={formData.start_time}
                  // onChange={handleChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="End Time"
                  type="time"
                  name="end_time"
                  value={formData.end_time}
                  // onChange={handleChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Duration (in minutes)"
                  type="number"
                  name="duration"
                  value={formData.duration}
                  // onChange={handleChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                />
              </Grid>

              {/* Personal Information */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Contact"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phnNo"
                  value={formData.phnNo}
                  onChange={handleChange}
                />
              </Grid>

              {/* Other Fields */}
              {/* <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Amount (in paise)"
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Organization Name"
                  name="insName"
                  value={formData.insName}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  // select
                  fullWidth
                  label="Booked By"
                  name="bookedBy"
                  value={formData.bookedBy}
                  // onChange={handleChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light grey background
                  }}
                >
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="GST No."
                  name="gstNo"
                  value={formData.gstNo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Gov ID"
                  name="govId"
                  value={formData.govId}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Remark"
                  name="remark"
                  value={formData.remark}
                  onChange={handleChange}
                />
              </Grid>

              {/* Action Buttons */}
              <Grid item xs={12} sx={{ mt: 3 }}>
                <Box display="flex" justifyContent="space-between">
                  <Button variant="contained" onClick={() => navigate(`/managePressConfHall`)}>
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpdateBooking}
                    disabled={!isModified} // Disable if no changes
                  >
                    Save Changes
                  </Button>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Typography color="error">No booking details found.</Typography>
          )}
        </Paper>
      </Container>
      <Footer />
    </DashboardLayout>
  );
}

export default EditBooking;
